import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import {
  FaBuilding,
  FaUsers,
  FaAward,
  FaHardHat,
} from "react-icons/fa";

const AboutCounter = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const stats = [
    {
      icon: <FaBuilding />,
      count: 500,
      suffix: "+",
      title: "Projects Completed",
    },
    {
      icon: <FaUsers />,
      count: 1000,
      suffix: "+",
      title: "Happy Clients",
    },
    {
      icon: <FaAward />,
      count: 10,
      suffix: "+",
      title: "Years Experience",
    },
    {
      icon: <FaHardHat />,
      count: 50,
      suffix: "+",
      title: "Expert Team",
    },
  ];

  return (
    <section
      ref={ref}
      className="relative py-24 overflow-hidden bg-[#082B57]"
    >
      {/* Background Shapes */}

      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute -top-20 -left-20 w-48 h-48 md:w-64 md:h-64 border border-white rounded-full"></div>

        <div className="absolute bottom-0 right-0 w-80 h-80 md:w-[500px] md:h-[500px] border border-white rounded-full"></div>
      </div>

      <div className="container-custom relative z-10">

        {/* Heading */}

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Our Achievements
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-white mt-4">
            Building Success Through
            <span className="text-[#F59E0B]">
              {" "}Experience & Excellence
            </span>
          </h2>

          <p className="text-white/70 mt-6 leading-8">
            Over the years, AZ Construction has successfully
            delivered projects, built lasting relationships,
            and earned the trust of clients across multiple sectors.
          </p>

        </div>

        {/* Counters */}

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

          {stats.map((item, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 text-center hover:-translate-y-2 transition duration-300"
            >

              <div className="w-20 h-20 mx-auto rounded-2xl bg-[#F59E0B] flex items-center justify-center text-white text-3xl">
                {item.icon}
              </div>

              <h3 className="text-5xl font-bold text-white mt-6">

                {inView && (
                  <CountUp
                    end={item.count}
                    duration={3}
                  />
                )}

                {item.suffix}

              </h3>

              <p className="text-white/70 mt-3 text-lg">
                {item.title}
              </p>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default AboutCounter;